module.exports = __webpack_public_path__ + "static/img/shangjia2.7922695.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xieyi/shangjia2.jpg
// module id = 1421
// module chunks = 1